export * from './datentransfer.service';
import { DatentransferService } from './datentransfer.service';
export const APIS = [DatentransferService];
